import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow js-main-content" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = {
  key: 0,
  class: "_flex _jc-c _mt-3"
}
const _hoisted_4 = { class: "_flex _jc-c _mt-3" }
const _hoisted_5 = {
  key: 2,
  class: "gfu-blog__item"
}
const _hoisted_6 = { class: "gfu-subheading gfu-subheading--main _pb-3" }
const _hoisted_7 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_blog_post_details_card = _resolveComponent("blog-post-details-card")
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_skeleton_blog_post_list = _resolveComponent("skeleton-blog-post-list")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, { class: "gfu-blog" }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        ($options.hasItems)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedItems, (post) => {
                return (_openBlock(), _createBlock(_component_blog_post_details_card, {
                  key: post.urlName,
                  "blog-post": post,
                  "is-preview": "",
                  class: "mb-4"
                }, null, 8 /* PROPS */, ["blog-post"]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($options.isMoreVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_processing_button, {
                      theme: "outline",
                      "is-processing": _ctx.isProcessing,
                      onClick: $options.onMore
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["is-processing", "onClick"])
                  ]))
                : _createCommentVNode("v-if", true),
              ($options.canLoadMoreRows)
                ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                    key: 1,
                    onLoadMore: $options.onMore
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_processing_button, { "is-processing": true }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onLoadMore"]))
                : _createCommentVNode("v-if", true)
            ]))
          : (_ctx.isProcessing)
            ? (_openBlock(), _createBlock(_component_skeleton_blog_post_list, { key: 1 }))
            : (!_ctx.isProcessing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_base_heading, {
                    variant: "decorative",
                    tag: "h2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.Blog.PageHeader), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.Blog.EmptyStateListParagraph), 1 /* TEXT */),
                  _createElementVNode("a", {
                    class: "gfu-link gfu-link--accent",
                    href: $props.mainPageLink
                  }, _toDisplayString(_ctx.Resources.Blog.BackToMainPageLink), 9 /* TEXT, PROPS */, _hoisted_7)
                ]))
              : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}